import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	file: null,
	name: null
}

const drawerSlice = createSlice({
	name: 'drawer',
	initialState,
	reducers: {
		openDrawer: (state, action) => {
			if (action.payload.file) return { ...state, ...{ file: action.payload.file, name: action.payload.name } };
			return { ...state, ...action.payload }
		},
		closeDrawer: (state) => {
			return { ...state, ...{ name: null } };
		}
	},
});

export const { openDrawer, closeDrawer } = drawerSlice.actions;

export default drawerSlice.reducer